



























import { Component } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { mixins } from "vue-class-component";
import LoadingMixin from "@/mixins/LoadingMixin";
import ContentMixin from "@/mixins/ContentMixin";
import Sections from "@/components/home-room/Sections.vue";
import { IPeriods } from "@/store/modules/auth/types";

const namespace: string = "sectionModule";

@Component({
  name: "home-room",
  components: {
    Sections,
  },
})
export default class HomeRoom extends mixins(LoadingMixin, ContentMixin) {
  @Action("checkHomeRoonOn", { namespace: "authModule" })
  private checkHomeRoonOn!: () => Promise<boolean>;

  @Action("fetchSections", { namespace })
  private sections!: any;

  @Getter("periods", { namespace })
  private periods!: IPeriods;

  @Getter("isHomeRoomOn", { namespace: "authModule" })
  private isHomeRoomOn!: string;

  public async loadData(): Promise<void> {
    // Progress bar
    this.$Progress.start();
    try {
      this.isLoading = true;

      await this.checkHomeRoonOn();

      if (this.isHomeRoomOn) {
        await this.sections();
      }

      // Progress bar looking good
      this.$Progress.finish();
    } catch (e) {
      this.isLoading = false;
      this.$Progress.fail();
      throw e;
    } finally {
      this.isLoading = false;
    }
  }

  public beforeMount() {
    this.loadData();
  }
}
